import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import MessageContentCard from "./MessageContentCard";
import ComposeMessageForm from "./ComposeMessageForm";
import { Loader } from "cxa-components";
import { connect } from "react-redux";
import { compose } from "recompose";
import { getChildrenMessages, postMessage, postMessageSuccess } from "actions/messagingActions";
import withLoadChildrenMessages from "./withLoadChildrenMessages";

const mapStateToProps = state => {
  const {
    common: {
      messaging: {
        menu: { isReadEnabled = true, isWriteEnabled = true },
      },
    },
    messaging: {
      childrenMessages: { byId, messages, isfetching } = {},
      rootMessages: { byId: rootById, messages: rootMessageList } = {},
    },
  } = state;

  return {
    isReadEnabled,
    isWriteEnabled,
    childrenMessages: {
      byId,
      messages,
      isfetching,
    },
    rootMessages: {
      byId: rootById,
      messages: rootMessageList,
    },
  };
};

const mapDispatchToProps = {
  getChildrenMessages,
  postMessage,
  postMessageSuccess,
};

const MessageReadingPane = ({
  isWriteEnabled,
  isComposeMessage = false,
  isReplyMessage = false,
  onReplyMessage,
  onPostMessage,
  onPostMessageSuccess,
  isReadingMode,
  isNarrowScreen = false,
  childrenMessages: { messages, isfetching },
}) => {
  if (isComposeMessage) return null;

  if (isfetching) return <Loader />;

  const readingModeCls = classnames({ "message-reply__disabled": isReadingMode });

  return (
    <div>
      <section className="message-reading-pane">
        {messages.map((message = {}) => {
          return <MessageContentCard key={message.pkMessage} {...message} />;
        })}
      </section>
      {isWriteEnabled && (
        <section className="message-reply">
          <ComposeMessageForm
            className={readingModeCls}
            isComposeMessage={isComposeMessage}
            isReplyMessage={isReplyMessage}
            onPostMessage={onPostMessage}
            onPostMessageSuccess={onPostMessageSuccess}
            isReadingMode={isReadingMode}
            onReplyMessage={onReplyMessage}
            isNarrowScreen={isNarrowScreen}
            subject={messages && messages.length > 0 ? messages[0].subject : ""}
            parentMessage={messages && messages.length > 0 ? messages[0] : null}
          />
        </section>
      )}
    </div>
  );
};

const enhanceMessageReadingPane = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withLoadChildrenMessages
);

MessageReadingPane.propTypes = {
  isReadEnabled: PropTypes.bool,
  isWriteEnabled: PropTypes.bool,
  isComposeMessage: PropTypes.bool.isRequired,
  isFileAttached: PropTypes.bool.isRequired,
  isReplyMessage: PropTypes.bool.isRequired,
  onReplyMessage: PropTypes.func.isRequired,
  onPostMessage: PropTypes.func.isRequired,
  onPostMessageSuccess: PropTypes.func.isRequired,
  isReadingMode: PropTypes.bool.isRequired,
  isNarrowScreen: PropTypes.bool.isRequired,
  childrenMessages: PropTypes.object.isRequired,
  rootMessages: PropTypes.object,
};

export default enhanceMessageReadingPane(MessageReadingPane);



// WEBPACK FOOTER //
// ./components/inAppMessages/MessageReadingPane.js